/**
 * Transactions Page
 * 
 * Standalone page for viewing transaction history.
 */

import { HomeHeader } from '../home/HomeHeader'
import { useAuth } from '../../contexts/AuthContext'
import { useNavigate } from 'react-router-dom'
import { TransactionHistory } from './TransactionHistory'

export function TransactionsPage() {
  const { user, logout } = useAuth()
  const navigate = useNavigate()

  const handleLogout = async () => {
    try {
      await logout()
      navigate('/')
    } catch (error) {
      console.error('Logout failed:', error)
    }
  }

  return (
    <div className="transactions-page min-h-screen bg-background">
      <HomeHeader user={user} onLogout={handleLogout} />
      
      <div className="container mx-auto px-4 py-6">
        {/* Compact Header */}
        <div className="flex items-center gap-3 mb-6">
          <div className="w-2 h-8 bg-primary rounded-full"></div>
          <div>
            <h1 className="text-2xl font-bold text-foreground">Transactions</h1>
            <p className="text-sm text-muted-foreground">
              View your payment and reward history
            </p>
          </div>
        </div>

        {/* Transaction History */}
        <TransactionHistory />
      </div>
    </div>
  )
}

